import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthorizationService } from '@core/authorization/services/authorization.service';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';
import { ToastService } from '@core/toast/toast.service';

export const isNotMigratedUserGuard: CanMatchFn = () => {
  const authorizationService = inject(AuthorizationService);
  const toastService = inject(ToastService);
  const router = inject(Router);

  if (!authorizationService.isMigratedUser()) {
    return true;
  }

  toastService.showWarningToast('bis-migration.section-unavailable');
  return router.createUrlTree([TopNavigationPath.Home]);
};
